/**
 * scanScopeApi.ts - perimetre du scan par tenant (produits M365 exclus).
 *
 * Endpoints :
 *   GET  /api/clients/scan-scope   - lecture (tous roles)
 *   POST /api/clients/scan-scope   - update (admin + auditor)
 *
 * Format d echange avec le worker RunScan : clients.scanScope = {
 *   excludedProducts: ['intune', 'purview', ...]
 * }
 */
import { apiFetch } from './apiClient';

export type ScanScopeProduct =
  | 'intune'
  | 'exchange'
  | 'purview'
  | 'teams'
  | 'powerPlatform'
  | 'defenderXdr'
  | 'mcas';

export const SCAN_SCOPE_PRODUCTS: ScanScopeProduct[] = [
  'intune', 'exchange', 'purview', 'teams', 'powerPlatform', 'defenderXdr', 'mcas',
];

export interface AvailableProduct {
  code:           ScanScopeProduct;
  controlsCount:  number;
}

export interface ScanScope {
  excludedProducts:  ScanScopeProduct[];
  availableProducts: AvailableProduct[];
  updatedAt:         string | null;
  updatedBy:         string | null;
}

export const scanScopeApi = {
  /** Retourne le perimetre actuel + meta produits dispos. */
  get: () => apiFetch<ScanScope>('/clients/scan-scope'),

  /** Met a jour la liste des produits exclus (admin + auditor uniquement). */
  update: (excludedProducts: ScanScopeProduct[]) =>
    apiFetch<{ excludedProducts: ScanScopeProduct[]; updatedAt: string; updatedBy: string }>(
      '/clients/scan-scope',
      {
        method: 'POST',
        body:   JSON.stringify({ excludedProducts }),
        headers: { 'Content-Type': 'application/json' },
      },
    ),
};
